import React from 'react';
import { Outlet  } from "react-router-dom";
const ErrorLayout = () => {
  return (
    <>
      <Outlet/>
    </>
  );
}

export default ErrorLayout;
